export default {
    getUser(state) {
        return state.user
    },

    getUserProperty: (state) => (property) => {
        return state.user.user[property]
    },
}